import { useEffect, useRef } from 'react';

export function useActiveTabInterval(callback, delay, active = true) {
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    let intervalId = null;

    const tick = () => {
      if (savedCallback.current) {
        savedCallback.current();
      }
    };

    const start = () => {
      if (document.visibilityState === 'visible' && active && delay != null) {
        intervalId = setInterval(tick, delay);
      }
    };

    const stop = () => {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
    };

    const handleVisibilityChange = () => {
      stop();
      start();
    };

    start();
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      stop();
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [delay, active]);
}
